import { useTeamConfig } from "@/global/hooks/useTeamConfig";
import { routes } from "@/global/routes";
import { useCssMediaQuery } from "@/shared/base/hooks/useCssMediaQuery";
import {
  Box,
  ListItemIcon,
  MenuItem,
  Divider,
  Paper,
  Container,
  Stack,
  useTheme,
  ListItemText,
} from "@mui/material";
import { useRouter } from "next/router";
import { AiOutlineCreditCard, AiOutlineGift } from "react-icons/ai";
import NextImage from "next/image";
import { extractUrlParams } from "@/global/utils/utils";
import OptionsMenu from "../OptionsMenu/OptionsMenu";
import CreditCardRoundedIcon from "@mui/icons-material/CreditCardRounded";
import RedeemRoundedIcon from "@mui/icons-material/RedeemRounded";
import React from "react";
import AddCardIcon from "@mui/icons-material/AddCard";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";

export function PurchaseCreditNavMenuItems(props: {
  hidePurchaseCredit?: boolean;
  hideHome?: boolean;
}) {
  const { teamSchema } = useTeamConfig();
  const router = useRouter();

  return (
    <Box>
      {!props.hidePurchaseCredit ? (
        <MenuItem
          sx={{ paddingRight: "24px", mt: "8px" }}
          onClick={() =>
            router.push({
              pathname: routes.purchaseCredit,
              query: {
                teamSchema,
              },
            })
          }
        >
          <ListItemIcon>
            <AddCardIcon />
          </ListItemIcon>
          <ListItemText>Add Credit</ListItemText>
        </MenuItem>
      ) : null}

      {!props.hideHome ? (
        <MenuItem
          sx={{ paddingRight: "24px" }}
          onClick={() =>
            router.push({
              pathname: routes.purchaseSeats,
              query: {
                teamSchema,
              },
            })
          }
        >
          <ListItemIcon>
            <HomeOutlinedIcon />
          </ListItemIcon>
          <ListItemText>Home</ListItemText>
        </MenuItem>
      ) : null}

      <Divider />
    </Box>
  );
}
